import React, { useState, useCallback, useRef } from "react";
import { Box, Typography, Stack, Button, TextField, Chip } from "@mui/material";

import "./fileuploadStyles.scss";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

const acceptedMimeTypes = ["image/jpeg", "image/png", "text/csv"];

const DragAndDropUpload: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const dropAreaRef = useRef<HTMLDivElement>(null);

  const handleFile = useCallback((selectedFile: File) => {
    if (acceptedMimeTypes.includes(selectedFile.type)) {
      setFile(selectedFile);
    } else {
      alert("Invalid file type. Please upload a JPG, PNG, or CSV file.");
    }
  }, []);

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    const { files } = event.dataTransfer;
    if (files.length > 0) {
      handleFile(files[0]);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (dropAreaRef.current) {
      dropAreaRef.current.style.borderColor = "#000";
    }
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (dropAreaRef.current) {
      dropAreaRef.current.style.borderColor = "#ccc";
    }
  };

  const handleFileInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { files } = event.target;
    if (files && files.length > 0) {
      handleFile(files[0]);
    }
  };

  const handleDelete = () => {
    // console.info("You clicked the delete icon.");
  };

  return (
    <>
      <Box
        ref={dropAreaRef}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        className="box__input"
        sx={{
          border: "2px dashed #ccc",
          padding: "20px",
          textAlign: "center",
          cursor: "pointer",
        }}
        onClick={() => {
          const input = document.getElementById("fileInput");
          if (input) {
            input.click();
          }
        }}
      >
        <Stack
          direction="column"
          spacing={1}
          justifyContent="center"
          alignItems="center"
        >
          <>
            {/* <InsertDriveFileIcon color="success" sx={{ fontSize: "50px" }} /> */}

            <Box className="textCenter textTruncate pt1">
              {file && <small>{file.name}</small>}
            </Box>
          </>
          <CloudUploadIcon color="info" sx={{ fontSize: "50px" }} />
          <label
            htmlFor="file"
            style={{
              fontSize: "20px",
              fontWeight: 500,
              color: "rgba(0,0,0,0.6)",
            }}
          >
            Drag and drop your file here or
          </label>
          <>
            <input
              type="file"
              id="fileInput"
              hidden
              onChange={handleFileInputChange}
              //   disabled={!!file || selectedFileData?.filename}
            />
            <Button
              variant="contained"
              component="label"
              className="primaryLiteBtn"
              //   disabled={!!file || selectedFileData?.filename}
            >
              Choose File
            </Button>
          </>
        </Stack>
      </Box>

      <Stack
        direction="row"
        columnGap={2}
        justifyContent="space-between"
        className="mt1 mb2"
      >
        <Typography variant="caption">
          Allowed file formats are .pdf, .doc or .docx
        </Typography>
        <Typography variant="caption">{` Max file size 50 MB`}</Typography>
      </Stack>

      <TextField
        id="textfield_id"
        fullWidth
        label="Protocol Name"
        variant="standard"
      />
      <Chip
        label="IHC-PD-L1.pdf"
        size="small"
        color="primary"
        variant="outlined"
        onDelete={handleDelete}
        sx={{ mt: 0.5 }}
      />
    </>
  );
};

export default DragAndDropUpload;
